import { BreakpointObserver, BreakpointState } from '@angular/cdk/layout';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.css'],
})
export class NavBarComponent implements OnInit {
  public useWhiteLogo: boolean;
  public isSmartPhone: boolean;
  public onLandingPage: boolean;
  public onServicesPage: boolean;
  public onContactUsPage: boolean;

  currentSection = 'home';

  constructor(
    public breakpointObserver: BreakpointObserver,
    private _router: Router
  ) {}

  ngOnInit(): void {
    this.useWhiteLogo = true;
    this.isSmartPhone = false;

    this.onLandingPage = false;
    this.onServicesPage = false;
    this.onContactUsPage = false;

    this.breakpointObserver
      .observe(['(max-width: 768px)'])
      .subscribe((state: BreakpointState) => {
        if (state.matches) {
          this.useWhiteLogo = false;
          this.isSmartPhone = true;
        } else {
          this.isSmartPhone = false;
        }
      });

    if (this._router.url.indexOf('services') > 0) {
      this.onServicesPage = true;
    } else if (this._router.url.indexOf('contact-us') > 0) {
      this.onContactUsPage = true;
    } else {
      this.onLandingPage = true;
    }
  }

  /**
   * Window scroll method
   */
  windowScroll() {
    const navbar = document.getElementById('navbar');
    if (
      document.body.scrollTop >= 50 ||
      document.documentElement.scrollTop > 50
    ) {
      navbar.classList.add('nav-sticky');
      this.useWhiteLogo = false;
    } else {
      navbar.classList.remove('nav-sticky');
      this.useWhiteLogo = true;
    }
  }

  /**
   * Toggle navbar
   */
  toggleMenu() {
    document.getElementById('navbarCollapse').classList.toggle('show');
  }
}
